import {medicalExaminationService, sharedDirectory} from "api";

const getIcdList = async () => {
  try {
    const response = await medicalExaminationService.getIcdList();
    localStorage.setItem("listIcd", JSON.stringify(response?.data || null));
  } catch (error) {}
};
const getListCommune = async () => {
  try {
    let response = await sharedDirectory.searchCommune({
      name: "",
    });
    localStorage.setItem("listCommune", JSON.stringify(response ?? []));
  } catch (err) {}
};
export {getIcdList, getListCommune};
